﻿// re-export all submission http services for easier importing
export * from './caching.repository';
export * from './address.repository';
export * from './billingstatement.repository';
export * from './code.repository';
export * from './location.repository';
export * from './user.repository';
export * from './payment.repository';
export * from './policy.repository';
export * from './policyholder.repository';
export * from './policyholderuser.repository';
export * from './question.repository';
export * from './questionresponse.repository';
export * from './submission.repository';
export * from './vehicle.repository';
export * from './policysummary.repository';
export * from './tokenrequest.repository';
export * from './lineofbusinessratingfactors.repository';
export * from './phone.repository';
export * from './eventLog.repository';
export * from './submissionRequest.repository';
export * from './brand.repository';
export * from './vertical.repository';